import angular from 'angular'
import routers from './routers.js'
import stampDutyreportQueryCtrl from './stampDutyreportQueryCtrl.js'

export default angular
  .module('declaration.stampDuty.stampDutyreportQuery', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('stampDutyreportQueryCtrl', stampDutyreportQueryCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/stampDuty/stampDutyreportQuery/index.js